import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { getFiltersDate } from "@oldDashboard/legacyUtils";
import { setEngagementTeamAction } from "@oldDashboard/legacyActions/dashboardClient";

interface useEngagementTeamProps { affiliateSelected: String, launchSelected: String, timePeriods:TimePeriods[], timePeriodSelected: string, searching: boolean }

const useEngagementTeam = (props: useEngagementTeamProps) => {
    const { affiliateSelected, launchSelected, timePeriods, timePeriodSelected, searching } = props;
    const [isLoading, setIsLoading] = useState(false);
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);

    useEffect( () => {
        fetchEngagementTeam();
    }, [searching, launchSelected]);

    const fetchEngagementTeam = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getEngagementTeam(affiliateSelected, launchSelected, startDate, endDate, timePeriodSelected);
            if(response){
                setEngagementTeamAction(response);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, fetchEngagementTeam }
}

export default useEngagementTeam;